<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
        >
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        ref="table"
        hover
        responsive
        class="mt-2"
        :per-page="tableSettings.perPage"
        :current-page="tableSettings.currentPage"
        :items="myProvider"
        :fields="tableSettings.fields"
        :sort-by.sync="tableSettings.sortBy"
        :sort-desc.sync="tableSettings.sortDesc"
        :sort-direction="tableSettings.sortDirection"
        :filter="tableSettings.filter"
        :filter-included-fields="tableSettings.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{ tableSettings.currentPage * tableSettings.perPage - tableSettings.perPage + (data.index + 1) }}
        </template>

        <template #cell(active)="data">
          {{ data.item.active === 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(login_local)="data">
          {{ data.item.login_local === 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(login_sso)="data">
          {{ data.item.login_sso === 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>

        <template #cell(actions)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditForm(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableSettings.perPage"
              :options="tableSettings.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableSettings.currentPage"
            :total-rows="tableSettings.totalRows"
            :per-page="tableSettings.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-employee-form"
      scrollable
      no-close-on-backdrop
      title="Edit Employee"
      @ok="onConfirmAction"
    >
      <ValidationObserver
        ref="form"
      >
        <form
          role="form"
          novalidate
        >
          <b-form-group>
            <label for="email">Email</label>
            <b-input
              id="email"
              v-model="employee.email"
              type="text"
              :disabled="true"
            />
          </b-form-group>

          <b-form-group>
            <label for="first_name">First Name</label>
            <b-input
              id="first_name"
              v-model="employee.first_name"
              type="text"
              :disabled="true"
            />
          </b-form-group>
          <b-form-group>
            <label for="middle_name">Middle Name</label>
            <b-input
              id="middle_name"
              v-model="employee.middle_name"
              type="text"
              :disabled="true"
            />
          </b-form-group>

          <b-form-group>
            <label for="last_name">Last Name</label>
            <b-input
              id="last_name"
              v-model="employee.last_name"
              type="text"
              :disabled="true"
            />
          </b-form-group>

          <ValidationProvider
            #default="{ errors }"
            name="password"
            vid="password"
            rules="min:8|confirmed:password_confirmation"
          >
            <b-form-group>
              <label for="password">Password <span>(Leave blank when not changing password)</span></label>
              <b-input
                id="password"
                v-model="employee.password"
                type="password"
                :state="errors.length > 0 ? false : null"
                placeholder="enter password"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="password confirmation"
            vid="password_confirmation"
            rules="min:8"
          >
            <b-form-group>
              <label for="password_confirmation">Password Confirmation <span>(Leave blank when not changing password)</span></label>
              <b-input
                id="password_confirmation"
                v-model="employee.password_confirmation"
                type="password"
                :state="errors.length > 0 ? false : null"
                placeholder="enter password confirmation"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <b-form-group>
            <label for="organization_name">Organization Name</label>
            <b-input
              id="organization_name"
              v-model="employee.organization_name"
              type="text"
              :disabled="true"
            />
          </b-form-group>

          <b-form-group>
            <label for="position_name">Position Name</label>
            <b-input
              id="position_name"
              v-model="employee.position_name"
              type="text"
              :disabled="true"
            />
          </b-form-group>

          <div
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="employee.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="isBusy"
            >
              Is Active?
            </b-form-checkbox>
          </div>

          <div
            class="form-group"
          >
            <b-form-checkbox
              id="is_manager"
              v-model="employee.is_manager"
              name="is_manager"
              value="1"
              unchecked-value="0"
              :disabled="isBusy"
            >
              Is Manager?
            </b-form-checkbox>
          </div>

          <div
            class="form-group"
          >
            <b-form-checkbox
              id="login_local"
              v-model="employee.login_local"
              name="login_local"
              value="1"
              unchecked-value="0"
              :disabled="isBusy"
            >
              Local Login?
            </b-form-checkbox>
          </div>

          <div
            class="form-group"
          >
            <b-form-checkbox
              id="login_sso"
              v-model="employee.login_sso"
              name="login_sso"
              value="1"
              unchecked-value="0"
              :disabled="isBusy"
            >
              SSO Login?
            </b-form-checkbox>
          </div>
        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          :disabled="isBusy"
          @click="ok()"
        >
          Update Record
        </b-button>
        <b-button
          variant="danger"
          :disabled="isBusy"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { AxiosError, AdminEmployeeService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'AdminEmployeeAccounts',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Employee Accounts'
    }
  },

  mixins: [formatter],

  data () {
    return {
      isBusy: false,
      employee: {
        id: 0,
        active: 0,
        email: '',
        password: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        organization_name: '',
        position_name: '',
        login_local: 0,
        login_sso: 0,
        is_manager: 0
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'email', sortable: true },
          { key: 'first_name', sortable: true },
          { key: 'middle_name', sortable: false },
          { key: 'last_name', sortable: true },
          { key: 'organization_name', label: 'organization' },
          { key: 'position_name', label: 'position' },
          { key: 'login_local', label: 'LOCAL LOGIN?' },
          { key: 'login_sso', label: 'SSO LOGIN?' },
          { key: 'active', label: 'IS ACTIVE?' },
          { key: 'updated_at', formatter: this.dateTimeFormatter, sortable: true }
        ]
      }
    }
  },

  mounted () {
    core.index()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await AdminEmployeeService.get(`page=${ctx.currentPage}&per_page=${ctx.perPage}&sort=${ctx.sortBy}&sort_desc=${ctx.sortDesc}&filter_text=${ctx.filter}`)
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    onShowAddForm () {
      this.$bvModal.show('modal-employee-form')
    },

    onShowEditForm (item) {
      console.log(item)
      this.employee.id = item.id
      this.employee.active = item.active
      this.employee.email = item.email
      this.employee.password = ''
      this.employee.password_confirmation = ''
      this.employee.first_name = item.first_name
      this.employee.middle_name = item.middle_name
      this.employee.last_name = item.last_name
      this.employee.organization_name = item.organization_name
      this.employee.position_name = item.position_name
      this.employee.login_local = item.login_local
      this.employee.login_sso = item.login_sso
      this.employee.is_manager = item.is_manager
      this.$bvModal.show('modal-employee-form')
    },

    async onConfirmAction (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          this.$swal.fire({
            icon: 'question',
            title: 'Do you really want to save changes?',
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              return this.onFormPutSubmit()
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk('Oppss! There were problem with your inputs.', {
            title: 'Validation Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger'
          })
        }
      })
    },

    async onFormPutSubmit () {
      return new Promise((resolve, reject) => {
        this.isBusy = true
        AdminEmployeeService.put(this.employee).then(response => {
          this.isBusy = false
          this.$bvModal.hide('modal-employee-form')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: response.data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.table.refresh()
          })
        }).catch(error => {
          this.isBusy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.form.setErrors(error.message)
              resolve(error)
            }
          }
        })
      })
    }
  }
}
</script>
